import { Component } from '@angular/core';

@Component({
  selector: 'app-contact-item-skeleton',
  templateUrl: './contact-item-skeleton.component.html',
  styleUrl: './contact-item-skeleton.component.scss',
  standalone: true
})
export class ContactItemSkeletonComponent {
  readonly numberOfRows = new Array(4);
}
